var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"el-fade-in"}},[_c('div',{staticClass:"right_head_mbx"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._l((_vm.name),function(v,k){return _c('el-breadcrumb-item',{key:k},[_vm._v(_vm._s(v))])})],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }